import React from 'react';
import moment from 'moment';

import { getConfig } from '@fec/assets/js/utils/config.js';
import TeaserInfo from '@fec/frontend/elements/text/teaser-info/teaser-info';

import './play-search-result.scss';

const { IL_BASE_URL } = getConfig();
const DEFAULT_TRANSLATIONS = {
  allShows: 'Alle Sendungen',
  radioShow: 'Radiosendung',
  tvShow: 'Fernsehsendung',
};

export const PlaySearchResult = ({
  item,
  translations = DEFAULT_TRANSLATIONS,
  index,
}) => {
  const type = item.type.toLowerCase();
  let teaserInfo = '';
  let timeElement = '';

  const generateScaledImageUrl = (imageUrl, size) => {
    return `${IL_BASE_URL}/images/?imageUrl=${imageUrl}&format=jpg&width=${size}`;
  };

  // create srcset to display smaller images
  let sourceSet = `${generateScaledImageUrl(item.image, 240)} 240w,
                     ${generateScaledImageUrl(item.image, 320)} 320w,
                     ${generateScaledImageUrl(item.image, 480)} 480w,
                     ${generateScaledImageUrl(item.image, 720)} 720w`;

  // set width to choose appropriate image
  let imageSizes = '(max-width: 720px) 50vw, 33vw';

  if (item.show && item.duration) {
    const finalTime = moment.utc(item.duration).format('mm:ss');

    timeElement = (
      <div
        className="teaser-ng__medium-indicator-wrapper"
        aria-hidden="true"
        role="presentation">
        <div className="media-time-indicator">{finalTime}</div>
      </div>
    );

    teaserInfo = (
      <>
        <span className="h-offscreen">Laufzeit {finalTime} Minuten.</span>
        <TeaserInfo
          styleModifier={`teaser-info--${type}`}
          text={`${item.show.title}, ${moment(item.date).format('DD.MM.YYYY')}`}
        />
      </>
    );
  } else if (item.type === 'video' || item.type === 'audio') {
    teaserInfo = (
      <TeaserInfo
        styleModifier={`teaser-info--${type}`}
        text={translations.allShows}
      />
    );
  }

  return (
    <li className="collection-ng__teaser-item js-teaser-ng-item">
      <a
        className="teaser-ng js-teaser-ng teaser-ng--with-medium teaser-ng--theme-dark"
        href={item.link}
        data-referrer-track={`srg_override_mod1=play_srf&srg_override_mod2=search_result&srg_override_mod3=${type}&srg_override_mod4=${index}`}>
        <div className="teaser-ng__medium">
          <picture className="image-ng">
            <img
              className="image-ng__img"
              src={`${generateScaledImageUrl(item.image, 320)}`}
              srcSet={sourceSet}
              sizes={imageSizes}
              alt=""
              loading={index < 5 ? 'eager' : 'lazy'}
            />
            {timeElement}
          </picture>
        </div>

        <div className="teaser-ng__content" role="text">
          <span className="h-offscreen">
            {type === 'audio' ? translations.radioShow : translations.tvShow}
          </span>
          <div className="teaser-ng__text">
            <span className="teaser-ng__title">{item.title}</span>
          </div>
        </div>

        {teaserInfo && (
          <div className="teaser-ng__extras">
            <div className="teaser-meta js-teaser-meta" role="text">
              <div className="teaser-meta__ltr js-teaser-meta__ltr">
                {teaserInfo}
              </div>
            </div>
          </div>
        )}
      </a>
    </li>
  );
};

export default PlaySearchResult;
